import React from 'react';
import { MailIcon, PhoneIcon, BriefcaseIcon, CpuIcon, LinkedinIcon, DollarSignIcon, UsersIcon, TagsIcon, ClockIcon } from 'lucide-react';
export function EnrichmentFields() {
  return <section className="py-24 bg-slate-50" data-id="element-2711">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2712">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2713">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-2714">
            What our local business contact{' '}
            <span className="text-blue-600" data-id="element-2715">enrichment</span> adds to every
            record
          </h2>
          <p className="text-xl text-slate-600" data-id="element-2716">
            Turn basic local business names into complete, actionable profiles
            with 50+ enriched data fields.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2717">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2718">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2719">
              <MailIcon className="w-6 h-6" data-id="element-2720" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2721">
              Owner emails
            </h3>
            <p className="text-slate-600" data-id="element-2722">
              Verified email addresses for local business owners and
              decision-makers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2723">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2724">
              <PhoneIcon className="w-6 h-6" data-id="element-2725" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2726">
              Direct phones
            </h3>
            <p className="text-slate-600" data-id="element-2727">
              Direct dial and mobile numbers for key local business contacts.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2728">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2729">
              <BriefcaseIcon className="w-6 h-6" data-id="element-2730" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2731">
              Job titles
            </h3>
            <p className="text-slate-600" data-id="element-2732">
              Accurate roles like Founder, GM, or Marketing Director.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2733">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2734">
              <CpuIcon className="w-6 h-6" data-id="element-2735" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2736">
              Tech stack
            </h3>
            <p className="text-slate-600" data-id="element-2737">
              Technologies used by the local business (Shopify, Toast,
              Mindbody).
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2738">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2739">
              <LinkedinIcon className="w-6 h-6" data-id="element-2740" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2741">
              Social profiles
            </h3>
            <p className="text-slate-600" data-id="element-2742">
              LinkedIn, Instagram, and Facebook profiles for the business and
              owners.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2743">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2744">
              <DollarSignIcon className="w-6 h-6" data-id="element-2745" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2746">
              Revenue estimates
            </h3>
            <p className="text-slate-600" data-id="element-2747">
              Estimated annual revenue to help qualify your local business
              leads.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2748">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2749">
              <UsersIcon className="w-6 h-6" data-id="element-2750" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2751">
              Employee count
            </h3>
            <p className="text-slate-600" data-id="element-2752">
              Accurate company size metrics for better segmentation.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2753">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2754">
              <TagsIcon className="w-6 h-6" data-id="element-2755" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2756">
              Business categories
            </h3>
            <p className="text-slate-600" data-id="element-2757">
              Primary and secondary industry classifications.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2758">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2759">
              <ClockIcon className="w-6 h-6" data-id="element-2760" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2761">
              Operating hours
            </h3>
            <p className="text-slate-600" data-id="element-2762">
              Daily open and close times from their local business profile.
            </p>
          </div>
        </div>
      </div>
    </section>;
}